import { render, staticRenderFns } from "./CustomEditBox.vue?vue&type=template&id=73757520&scoped=true"
import script from "./CustomEditBox.vue?vue&type=script&lang=js"
export * from "./CustomEditBox.vue?vue&type=script&lang=js"
import style0 from "./CustomEditBox.vue?vue&type=style&index=0&id=73757520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73757520",
  null
  
)

export default component.exports